import { render, staticRenderFns } from "./active-order.pug?vue&type=template&id=56f396c4&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./active-order.scss?vue&type=style&index=0&id=56f396c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f396c4",
  null
  
)

export default component.exports